import React, { useEffect, useState } from "react";

function RedditAnalyticsDashboard() {
  const [logs, setLogs] = useState([]);

  useEffect(() => {
    fetch("/api/reddit/logs")
      .then((res) => res.json())
      .then((data) => setLogs(data))
      .catch((err) => console.error("Failed to load logs", err));
  }, []);

  return (
    <div className="p-4">
      <h2 className="text-2xl font-bold mb-4">📊 Reddit Bot Activity</h2>
      <table className="w-full table-auto border">
        <thead>
          <tr className="bg-gray-100 text-left">
            <th className="p-2">Subreddit</th>
            <th className="p-2">Title</th>
            <th className="p-2">Matched Keywords</th>
            <th className="p-2">Replied At</th>
            <th className="p-2">Link</th>
          </tr>
        </thead>
        <tbody>
          {logs.map((log) => (
            <tr key={log.postId} className="border-t">
              <td className="p-2">{log.subreddit}</td>
              <td className="p-2">{log.title}</td>
              <td className="p-2">{log.keywordsMatched.join(", ")}</td>
              <td className="p-2">{new Date(log.repliedAt).toLocaleString()}</td>
              <td className="p-2">
                <a href={log.permalink} target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">
                  View
                </a>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

export default RedditAnalyticsDashboard;